
import RestService from "../services/rest.service"

export const getEvaluateCycleList = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.get(`app/kpi/evaluate/dropdown/cycle`).then(
      (response) => {
        let data = response.data.data
        resolve(data)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    )
  })
}

export const getOrganizationList = (cycle_id) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.get(`app/kpi/evaluate/dropdown/organization/` + cycle_id).then(
      (response) => {
        let data = response.data.data
        resolve(data)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    )
  })
}